import { SingleForm } from 'src/app/shared/components/payments';

import { NameInputWrapper } from '../../../NameInputWrapper';
import { SubmitButton } from '../../../SubmitButton';
import type { SavedPaymentMethodOption } from '../../shared/types';

import { Alert } from './components/Alert';
import { CardStyleWrapper } from './components/CardStyleWrapper';
import { Header } from './components/Header';
import { useNewCreditCard } from './hooks/useNewCreditCard';

type Props = {
	selectedPaymentMethod: SavedPaymentMethodOption | null;
};

export const NewCreditCard: React.FC<Props> = ({ selectedPaymentMethod }) => {
	if (selectedPaymentMethod !== 'new') {
		return null;
	}

	const {
		data: { loading, disabled, ref, validationErrors, error },
		actions: { handleSubmit, onCardDetailsFieldFocus, setValidationErrors },
	} = useNewCreditCard();

	return (
		<form onSubmit={handleSubmit}>
			<div className="flex flex-col gap-7">
				<CardStyleWrapper selected>
					<div className="flex w-full flex-col gap-3 p-3 pb-4">
						<Header selected ref={ref} />
						<div className="flex flex-col gap-4">
							<NameInputWrapper disabled={loading} paymentType="creditCard" whiteBackground />
							<SingleForm
								onCardDetailsFieldFocus={onCardDetailsFieldFocus}
								whiteBackground
								setValidationErrors={setValidationErrors}
								validationErrors={validationErrors}
								disabled={loading}
							/>
						</div>
						<Alert error={error} />
					</div>
				</CardStyleWrapper>
				<SubmitButton disabled={disabled} loading={loading} />
			</div>
		</form>
	);
};
